// "1 item" / "3 items" for the shop-facing counts. The word comes from the
// translation keys `rituals.item` (singular) and `rituals.items` (plural), so
// it follows the user's language.
//
// ⚠️ Do NOT do this with i18next's `count` option: with one base key, i18next
// pluralisation looks for `key_one` / `key_other` and the fallback is
// unreliable (see the i18n section in CLAUDE.md). Picking the key ourselves is
// the whole trick.
//
// ⚠️ Data, not code: `rituals.item` exists in every language, but on 24/09/2026
// only EN carried a real value ("item"); DE/ES/FR/IT/NL/PL/PT still held the
// placeholder "item XX". Those have to be filled in the translation manager.
type Translate = (key: string) => string;

// Just the word, for places that style the number separately.
export function itemWord(count: number, t: Translate): string {
  return t(count === 1 ? "rituals.item" : "rituals.items");
}

// Number + word, e.g. "1 item" / "12 items".
export default function formatItemCount(count: number, t: Translate): string {
  return `${count} ${itemWord(count, t)}`;
}
